// Busy-Regel einer Research-Collection, wie im Backend (searchinsights-api api/helper/collectionBusyState.js):
// "creating"/"updating" zaehlt nur als laufend, solange der Import ein frisches Lebenszeichen (mdata.status_heartbeat)
// gibt. Stirbt der Worker waehrend des Imports (Deploy, Absturz), bliebe der Status sonst fuer immer stehen und die
// Collection dauerhaft gesperrt. Ohne Heartbeat (Altbestand) oder mit einem aelter als 10 Minuten ist der Vorgang
// abgebrochen: das Backend stellt die Collection beim Laden (Liste, einzelne Collection) auf Status "error"
// (mdata.status_error), zaehlt Count und Trend nach und informiert den Support. Die App zeigt deshalb den Status des
// Servers; nur ein verwaister Status, den der Server noch nicht umstellen konnte, wird wie "error" angezeigt.
// "error" ist nie busy: die Collection bleibt voll bedienbar, der naechste abgeschlossene Vorgang setzt sie auf "OK".
export const COLLECTION_HEARTBEAT_STALE_MS = 10 * 60 * 1000
export const COLLECTION_ERROR_STATUS = "error"
export const COLLECTION_ERROR_HINT =
    "There was a problem with the last update of this collection. The data shown is complete up to that point. Our support team has been notified."

export function isCollectionBusy(mdata) {
    if (!mdata || (mdata.status !== "creating" && mdata.status !== "updating")) return false
    if (!mdata.status_heartbeat) return false
    const heartbeat = new Date(mdata.status_heartbeat).getTime()
    if (!Number.isFinite(heartbeat)) return false
    return Date.now() - heartbeat < COLLECTION_HEARTBEAT_STALE_MS
}

// Der letzte Vorgang an der Collection ist abgebrochen (Status "error").
export function isCollectionInterrupted(mdata) {
    return Boolean(mdata) && effectiveCollectionStatus(mdata) === COLLECTION_ERROR_STATUS
}

// Status fuer die Anzeige: der Status des Servers; ein verwaister Busy-Status (noch nicht umgestellt) gilt als "error".
export function effectiveCollectionStatus(mdata) {
    if (!mdata) return undefined
    if ((mdata.status === "creating" || mdata.status === "updating") && !isCollectionBusy(mdata)) return COLLECTION_ERROR_STATUS
    return mdata.status
}
